import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=dce21d80&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce21d80')) {
      api.createRecord('dce21d80', component.options)
    } else {
      api.reload('dce21d80', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=dce21d80&", function () {
      api.rerender('dce21d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O1d7lCl53ceb/JS/comp/starrating.vue"
export default component.exports